import { STTileFlipMode } from '@tencent/slide-sdk-model';
import { ImageTileFlipType } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';

// 镜像模式 - sdk对上层类型映射
export const FLIP_VER3_MAP = new Map([
    [STTileFlipMode?.x, ImageTileFlipType.x],
    [STTileFlipMode?.y, ImageTileFlipType.y],
    [STTileFlipMode?.xy, ImageTileFlipType.xy],
    [STTileFlipMode?.none, ImageTileFlipType.NONE],
]);
